import React, { useEffect } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '../../../components/FormFields/Select';
import { fetchEquipmentTypesLookup } from '../../../actions/lookupActions';

const EquipmentTypeSelect = ({
    errors,
    fetchEquipmentTypesLookup,
    onBlur,
    onPatch,
    touched,
    values
}) => {
    const dispatch = useDispatch();
    const equipmentTypes = useSelector(
        ({ equipmentTypes }) => equipmentTypes
    );

    useEffect(() => {
        if (equipmentTypes.loading || equipmentTypes.data.length) {
            return;
        }
        dispatch(fetchEquipmentTypesLookup());
    }, []);

    function handleChange(event) {
        const { value } = event.target;
        const equipmentType = equipmentTypes.data.find(
            ({ id }) => id === value
        );
        onPatch({
            equipmentTypeId:   value,
            equipmentTypeName: equipmentType.name
        });
    }

    return (
        <Select
            error={equipmentTypes.error}
            errors={errors.equipmentTypeId}
            isLoading={equipmentTypes.loading}
            label="Equipment Type"
            name="equipmentTypeId"
            onBlur={onBlur}
            onChange={handleChange}
            required
            touched={touched.equipmentTypeId}
            value={values.equipmentTypeId}
        >
            {(equipmentTypes.data || []).map(({ id, name }) => (
                <MenuItem key={id} value={id}>{name}</MenuItem>
            ))}
        </Select>
    );
};


EquipmentTypeSelect.defaultProps = {
    errors:  {},
    fetchEquipmentTypesLookup,
    onBlur:  () => {},
    onPatch: () => {},
    touched: {},
    values:  {}
};

EquipmentTypeSelect.propTypes = {
    errors: shape({
        equipmentTypeId: string
    }),
    fetchEquipmentTypesLookup: func,
    onBlur:                    func,
    onPatch:                   func,
    touched:                   shape({
        equipmentTypeId: bool
    }),
    values: shape({
        equipmentTypeId: string
    })
};

export default EquipmentTypeSelect;
